import apiUrls from "../urls";

export default function (api) {
	return {
		postData(data) {
			return api.post(apiUrls.UPLOAD_VOUCHER, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
		},
		convertPdfToImage(pdfFile) {
			const formData = new FormData();
			formData.append("files[]", pdfFile);

			return api.post(apiUrls.CONVERT_PDF_TO_IMAGE, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
		},
	};
}
